var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      title: _vm.$t("label_essweb_punchManage_list_bluetooth_dialog_viewTitle"),
      width: 680,
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0 pb-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-switch", {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.iSEdited,
                            label: _vm.Data.status
                              ? _vm.$t(
                                  "label_essweb_punchManage_list_bluetooth_dialog_activeLabel"
                                )
                              : "",
                          },
                          model: {
                            value: _vm.Data.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "status", $$v)
                            },
                            expression: "Data.status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            TrigerInit: _vm.show,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            bindData: _vm.Data.criteria_bluetooth_name,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_nameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.criteria_bluetooth_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            TrigerInit: _vm.show,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            bindData: _vm.Data.criteria_bluetooth_description,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.criteria_bluetooth_description = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_majorCodeLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.Data.bluetooth_major_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "bluetooth_major_code", $$v)
                            },
                            expression: "Data.bluetooth_major_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_minorCodeLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.Data.bluetooth_minor_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "bluetooth_minor_code", $$v)
                            },
                            expression: "Data.bluetooth_minor_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_punchManage_list_bluetooth_dialog_siteNameLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.siteList,
                            "item-text": "site_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "single-line": "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "menu-props": {
                              offsetY: true,
                              transition: "slide-y-transition",
                              rounded: true,
                              contentClass: "elevation-4",
                            },
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_siteNameLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.site_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "site_uuid", $$v)
                            },
                            expression: "Data.site_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_bluetoothIdLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.bluetooth_device_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "bluetooth_device_uuid", $$v)
                            },
                            expression: "Data.bluetooth_device_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            max: _vm.Data.expired_utc_datetime,
                            defaultTime: _vm.Data.effective_utc_datetime,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_effectiveStartDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.Data.effective_utc_datetime = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            defaultTime: _vm.Data.expired_utc_datetime,
                            min: _vm.Data.effective_utc_datetime,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_expiredEndDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.Data.expired_utc_datetime = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_punchManage_list_bluetooth_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            "single-line": "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            placeholder: _vm.$t(
                              "label_essweb_punchManage_list_bluetooth_dialog_remarkLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "remarks", $$v)
                            },
                            expression: "Data.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.toSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }